import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useAuthContext, useLoadingContext, useVisitContext } from '@hooks';
import InputTextOutlined from '@components/InputTextOutlined';
import PrimaryButton from '@components/PrimaryButton';
import { AuthLayout } from '@layouts';
import { switchBetweenLabelAndPlaceholder } from '@utils';
import { ROUTES } from '@constants';

function VerificationCodeScreen({
  isVerificationScreen,
  root,
  nextScreen,
  email,
  handleClose,
}) {
  const { setIsLoading } = useLoadingContext();
  const [verificationCode, setVerificationCode] = useState('');

  const stringifyPlaceData = localStorage.getItem('place');
  const parsedPlaceData = JSON.parse(stringifyPlaceData);

  const [
    isPlaceholderVerificationCodeShow,
    setPlaceholderVerificationCodeShow,
  ] = useState(true);
  const [isLabelVerificationCodeShow, setLabelVerificationCodeShow] = useState(
    false,
  );
  const { verifyEmailWithCode } = useAuthContext();
  const { createVisit } = useVisitContext();
  const { t } = useTranslation('auth');
  const history = useHistory();

  const handleChangeVerificationCode = ({ target }) => {
    setVerificationCode(target.value);

    switchBetweenLabelAndPlaceholder({
      condition: target.value.length > 0,
      setLabel: setLabelVerificationCodeShow,
      setPlaceholder: setPlaceholderVerificationCodeShow,
    });
  };

  const handleDisplayPlaceholderInputCode = () => {
    setPlaceholderVerificationCodeShow(!isPlaceholderVerificationCodeShow);
  };

  const handleDisplayLabelOrPlaceholderCode = () => {
    if (verificationCode.length > 0) {
      setLabelVerificationCodeShow(true);
    } else {
      setPlaceholderVerificationCodeShow(true);
    }
  };

  const goToNextScreen = async () => {
    await createVisit({
      placeId: parsedPlaceData.placeId,
      tableId: parsedPlaceData.tableId,
    });

    setIsLoading(false);
    history.push(nextScreen);
  };

  const sendVerifyCode = async () => {
    setIsLoading(true);

    const res = await verifyEmailWithCode({
      email,
      code: verificationCode,
    });

    if (!res) return handleClose();

    if (root === ROUTES.ORDERS_SCREEN) {
      handleClose();
      return true;
    }

    await goToNextScreen();
  };

  return (
    <AuthLayout
      title={t('signIn.verificationTitle')}
      subTitle={
        'Link not working? We also send you a code that you can paste right here.'
      }
      open={isVerificationScreen}
      handleClose={handleClose}
      root={root}
    >
      <>
        <InputTextOutlined
          type="number"
          value={verificationCode}
          placeholder={t('signIn.verificationCode')}
          handleChangeInput={handleChangeVerificationCode}
          handleDisplayPlaceholderInput={handleDisplayPlaceholderInputCode}
          handleDisplayLabelOrPlaceholder={handleDisplayLabelOrPlaceholderCode}
          isPlaceholderInputDisplayed={isPlaceholderVerificationCodeShow}
          isLabelInputDisplayed={isLabelVerificationCodeShow}
        />
        <PrimaryButton handleClick={sendVerifyCode} text={'Verify'} />
      </>
    </AuthLayout>
  );
}

export default VerificationCodeScreen;
